<div class="section section--our-planet">
  <div class="container">
    <div class="section__title" *ngIf="randomProjects.length > 0">
      {{ 'HOMEPAGE.our_planet_heroes_title' | translate }}
    </div>
    <div class="our-planet__slider">
      <ngx-slick-carousel class="carousel" #slickModal="slick-carousel" [config]="slideConfig">
        <a
          ngxSlickItem
          class="our-planet__slider-item slide"
          *ngFor="let item of randomProjects"
          [routerLink]="['/' + RoutesPath.default.verified + '/' + item.id]"
          style="margin: 8px"
        >
          <img [attr.data-lazy]="imageThumb(item.afterImg)" alt="{{ item.name }}" />
        </a>
      </ngx-slick-carousel>
    </div>
  </div>
</div>
